/**
 * Poste revoque dans l'ERP (design, section 3) : ecran plein, en rouge, avec
 * icone et texte. Le statut est garde sur le poste : l'ecran reste apres un
 * redemarrage, meme hors ligne.
 */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import BlockIcon from '@mui/icons-material/Block';
import { palette } from './theme';

export default function RevokedScreen({ terminal }) {
    return (
        <Box
            role="alert"
            data-testid="ecran-poste-revoque"
            sx={{
                flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                gap: 3, p: 4, textAlign: 'center', bgcolor: palette.errorTint, color: palette.errorOnTint,
            }}
        >
            <BlockIcon sx={{ fontSize: 112 }} aria-hidden="true" />
            <Typography component="h1" sx={{ fontSize: 40, fontWeight: 800 }}>Poste révoqué</Typography>
            <Typography sx={{ fontSize: 24, maxWidth: 820 }}>
                Ce poste a été désactivé. Les ventes en attente sont envoyées, puis la caisse se verrouille.
            </Typography>
            {terminal && (
                <Typography sx={{ fontSize: 18 }}>
                    {[terminal.store_name, terminal.name].filter(Boolean).join(' · ')}
                </Typography>
            )}
        </Box>
    );
}
